exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".timer-resend {\n  margin: 0 1rem;\n  color: var(--primary-blue);\n  margin-left: 1rem; }\n", ""]);

// exports
